const InstagramSvg = ({
  height = 14,
  width = 14,
  viewBox = '0 0 14 14',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <g clipPath="url(#clip0_24458_18790)">
        <path
          d="M7 1.26175C8.869 1.26175 9.09067 1.26875 9.82917 1.30258C11.7262 1.38892 12.6122 2.289 12.6986 4.172C12.7324 4.90992 12.7388 5.13158 12.7388 7.00058C12.7388 8.87017 12.7318 9.09125 12.6986 9.82917C12.6117 11.7104 11.7279 12.6122 9.82917 12.6986C9.09067 12.7324 8.87017 12.7394 7 12.7394C5.131 12.7394 4.90933 12.7324 4.17142 12.6986C2.26975 12.6117 1.38833 11.7075 1.302 9.82858C1.26817 9.09067 1.26117 8.86958 1.26117 7C1.26117 5.131 1.26875 4.90992 1.302 4.17142C1.38892 2.289 2.27267 1.38833 4.17142 1.302C4.90992 1.26875 5.131 1.26175 7 1.26175ZM7 0C5.09892 0 4.86092 0.00816667 4.11425 0.042C1.57208 0.158667 0.15925 1.56917 0.0425833 4.11367C0.00816667 4.86092 0 5.09892 0 7C0 8.90108 0.00816667 9.13967 0.042 9.88633C0.158667 12.4285 1.56917 13.8413 4.11367 13.958C4.86092 13.9918 5.09892 14 7 14C8.90108 14 9.13967 13.9918 9.88633 13.958C12.4262 13.8413 13.8425 12.4308 13.9574 9.88633C13.9918 9.13967 14 8.90108 14 7C14 5.09892 13.9918 4.86092 13.958 4.11425C13.8437 1.57442 12.4314 0.15925 9.88692 0.0425833C9.13967 0.00816667 8.90108 0 7 0ZM7 3.4055C5.01492 3.4055 3.4055 5.01492 3.4055 7C3.4055 8.98508 5.01492 10.5951 7 10.5951C8.98508 10.5951 10.5945 8.98567 10.5945 7C10.5945 5.01492 8.98508 3.4055 7 3.4055ZM7 9.33333C5.71142 9.33333 4.66667 8.28917 4.66667 7C4.66667 5.71142 5.71142 4.66667 7 4.66667C8.28858 4.66667 9.33333 5.71142 9.33333 7C9.33333 8.28917 8.28858 9.33333 7 9.33333ZM10.7368 2.42375C10.2725 2.42375 9.89625 2.8 9.89625 3.26375C9.89625 3.7275 10.2725 4.10375 10.7368 4.10375C11.2006 4.10375 11.5762 3.7275 11.5762 3.26375C11.5762 2.8 11.2006 2.42375 10.7368 2.42375Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_24458_18790">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InstagramSvg;
